import { Trans } from '@lingui/macro'

import styles from './DiscountTooltip.module.scss'
import InfoBox from '../../core/InfoBox'

export const DiscountTooltip = () => (
    <InfoBox
        tooltipClassName={styles.infobox}
        hasToggleEnabled
        hasStopPropagationEnabled
        hideOnScrollThreshold={5}
    >
        <Trans id="cart.totals.discountTooltip">
            The discount is spread over all items in your shopping cart. In the
            event of a return, the amount to be received will be reduced by a
            proportional part of the discount.
        </Trans>
    </InfoBox>
)
